import { getTeamMemberForUserId } from '~/services/users'
import { TeamMember } from '~/cynqueModules/dataObjects/TeamMember'
import { handleAsyncDataErrors } from '~/cynqueModules/handleAsyncDataErrors'
import { getNuxtContext } from '~/cynqueModules/nuxtRuntime'
import type { ITeamMember } from '~/types/teamMember/models'
import type { TEntityId } from '~/types/models'

/**
 * Resolve the ITeamMember for a logged-in user id.
 *
 * Extracted verbatim from store/loggedInUser.js so the one piece of real
 * business logic in the store (service fetch + 404 handling + error routing)
 * lives in a plain, framework-agnostic function that is unit-testable now and
 * reusable unchanged by the Pinia store after the Nuxt 3 migration.
 *
 *   success -> enriched TeamMember(...)
 *   404     -> undefined (the login user is not a team-member user)
 *   other   -> routed through handleAsyncDataErrors (resolves to undefined)
 */
export async function resolveLoggedInTeamMember(
  userId: TEntityId
): Promise<ITeamMember | undefined> {
  const fn = `[cynqueModules/store/resolveLoggedInTeamMember] |`
  try {
    const teamMember = await getTeamMemberForUserId(userId)
    console.debug(`${fn} Returning teamMember`, teamMember)
    return TeamMember(teamMember)
  } catch (e: any) {
    if (e.statusCode && e.statusCode === 404) {
      console.debug(
        `${fn} login user is not teamMember user. Not setting loggedInTeamMember.`
      )
      return undefined
    } else {
      await handleAsyncDataErrors({
        callingMn: fn,
        error: e,
        context: getNuxtContext(),
      })
    }
  }
}
